import React from "react";
import "./EventosSection.css";
import evento_corporativo_1 from "./media/evento_corporativo_1.jpg";
import evento_informal from "./media/evento_informal.jpg";
import evento_corporativo_2 from "./media/evento_corporativo_2.jpeg";
import evento_formativo from "./media/evento_formativo.jpg";

export default function EventosSection() {
    return (
        <section className="coleccion-eventos-section" id="EventosSection">
            <p className="coleccion-eventos-titulo">Colección de eventos</p>
            <div className="coleccion-eventos-grid">
                <div className="grid-item evento-1">
                    <div className="evento-img-container">
                        <img src={evento_corporativo_1} alt="Evento Corporativo"/>
                    </div>
                    <div className="titulos-section-left">
                        <p className="titulo-evento">Evento Corporativo</p>
                        <p className="subtitulo-evento">Presentación revista "MÁS RARO QUÉ"</p>
                        <p className="footer-evento">Vila Viniteca - Perro Verde</p>
                    </div>
                </div>
                <div className="grid-item evento-2">
                    <div className="evento-img-container">
                        <img src={evento_informal} alt="Evento Informal"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-evento">Evento Informal</p>
                        <p className="subtitulo-evento">Cumpleaños 30 - Cristina</p>
                        <p className="footer-evento">Particular</p>
                    </div>
                </div>
                <div className="grid-item evento-3">
                    <div className="evento-img-container">
                        <img src={evento_corporativo_2} alt="Evento Corporativo"/>
                    </div>
                    <div className="titulos-section-left">
                        <p className="titulo-evento">Evento Corporativo</p>
                        <p className="subtitulo-evento">Presentación a medios - Confidencial</p>
                        <p className="footer-evento">Empresa Confidencial</p>
                    </div>
                </div>
                <div className="grid-item evento-4">
                    <div className="evento-img-container">
                        <img src={evento_formativo} alt="Evento Formativo"/>
                    </div>
                    <div className="titulos-section-rigt">
                        <p className="titulo-evento">Evento Formativo</p>
                        <p className="subtitulo-evento">FORUM DAC I - El Líder del Momento</p>
                        <p className="footer-evento">Dale al Coco con José Elias Navarro</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
